import { Component, OnInit } from '@angular/core';
import { CameraService } from '../../services/camera.service';

@Component({
  selector: 'app-cameras',
  templateUrl: './cameras.component.html',
  styleUrls: ['./cameras.component.css']
})
export class CamerasComponent implements OnInit {
  public cameras = [];

  constructor(protected cameraService: CameraService) {
    this.load();
  }

  ngOnInit() {
  }

  protected load() {
    this.cameraService.index().subscribe(cameras => {
      this.cameras = cameras;
    });
  }

  public delete(camera) {
    this.cameraService.destroy(camera).subscribe(() => this.load());
  }
}



// WEBPACK FOOTER //
// /Users/dade/work/sportclubby/sportclubby.livestreaming.frontend/src/app/components/cameras/cameras.component.ts